import React from "react";
import "./Fmdashbord.css";
import { Bar, Pie, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);

const Fmdashbord = () => {
  /* CHART DATA */
  const employeeData = {
    labels: ["Employees", "Payroll", "Payslip"],
    datasets: [
      {
        data: [83, 152, 152],
        backgroundColor: ["#6cdbeb", "#b8e994", "#c7b9ff"],
        borderRadius: 10,
      },
    ],
  };

  const payData = {
    labels: ["Gross Pay", "Net Pay", "Total Payout"],
    datasets: [
      {
        data: [287, 146, 146],
        backgroundColor: ["#ffb3c6", "#81ecec", "#ffeaa7"],
        borderWidth: 0,
      },
    ],
  };

  const deductionData = {
    labels: ["PF", "PT", "ESI", "Income Tax"],
    datasets: [
      {
        data: [167366, 14000, 0, 0],
        backgroundColor: ["#a29bfe", "#55efc4", "#fdcb6e", "#fab1a0"],
        cutout: "70%",
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 10,
          font: { size: 11 },
        },
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div className="finance-dashboard">

      {/* ===== TOP SUMMARY BOXES ===== */}
      <div className="summary-grid">
        <div className="summary-card blue">
          <p>Total Employees</p>
          <h2>83</h2>
        </div>

        <div className="summary-card green">
          <p>Payroll-Completed</p>
          <h2>152</h2>
        
        </div>

        <div className="summary-card mint">
          <p>Payslip Generated</p>
          <h2>152</h2>
        </div>

        <div className="summary-card pink">
          <p>Gross Pay</p>
          <h2>287</h2>
        </div>

        <div className="summary-card yellow">
          <p>Net Pay</p>
          <h2>146</h2>
        </div>

        <div className="summary-card lightgreen">
          <p>Total Payout</p>
          <h2>146</h2>
        </div>

        <div className="summary-card purple">
          <p>PF</p>
          <h2>₹1,67,366</h2>
        </div>

        <div className="summary-card sky">
          <p>PT</p>
          <h2>₹14,000</h2>
        </div>

        <div className="summary-card gray">
          <p>ESI</p>
          <h2>0</h2>
        </div>

        <div className="summary-card peach">
          <p>Income Tax</p>
          <h2>0</h2>
        </div>
      </div>

      {/* ===== CHART SECTION ===== */}
      <div className="charts-grid">
        <div className="chart-card">
          <h4>Employees & Payroll</h4>
          <div className="chart-sm">
            <Bar data={employeeData} options={options} />
          </div>
        </div>

        <div className="chart-card">
          <h4>Pay Overview</h4>
          <div className="chart-sm">
            <Pie data={payData} options={options} />
          </div>
        </div>

        <div className="chart-card">
          <h4>Deductions</h4>
          <div className="chart-sm">
            <Doughnut data={deductionData} options={options} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fmdashbord;
